module.exports = __webpack_public_path__ + "static/img/q2.5da0bcbd.jpg";